import { useEffect, forwardRef } from 'react';

const InquiryForm = forwardRef((props, ref) => {
  useEffect(() => {
    // Inject widget
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://widgets.nopaperforms.com/emwgts.js';
    document.body.appendChild(script);

    // Add message listener
    const handleWidgetMessage = (event) => {
      if (
        event.origin.includes('nopaperforms.com') &&
        typeof event.data === 'object' &&
        event.data.message === 'formSubmitted'
      ) {
        console.log('✅ Widget form successfully submitted!');

        // Trigger your API call here
        const formData = new FormData();
        formData.append('name', 'Deepak Sharma');
        formData.append('email', 'deepaksharma.muskowl@gmail.com');
        formData.append('contact', '8787686868');
        formData.append('zone_id', '31766');
        formData.append('city', '27239');
        formData.append('referother', '1500451');
        formData.append('course_id', '1500454');
        formData.append('subcourse_id', '1500463');
        formData.append('referred', 'SPSU Landing Page');

        fetch(
          'https://puadmin.modevcloud.com/student_module/api/student_api/save',
          {
            method: 'POST',
            body: formData,
          },
        )
          .then((res) => res.json())
          .then((res) => {
            console.log('✅ API Response:', res);
          })
          .catch((err) => {
            console.error('❌ API Error:', err);
          });
      }
    };

    window.addEventListener('message', handleWidgetMessage);

    return () => {
      window.removeEventListener('message', handleWidgetMessage);
    };
  }, []);

  return (
    <div
      ref={ref}
      className="text-white rounded-lg shadow-xl w-full max-w-md bottom-[0px] md:bottom-[-34px] relative"
    >
      <div className="bg-[#282365] opacity-95 rounded-b-[10px] font-poppins">
        <div
          className="npf_wgts rounded-b-[10px]"
          data-height="700px"
          data-w="898d4cde4c4a717d12b34937d505dd55"
        ></div>
      </div>
    </div>
  );
});

export default InquiryForm;
